import { render, staticRenderFns } from "./support.vue?vue&type=template&id=c6b8a3a2&"
import script from "./support.vue?vue&type=script&lang=ts&"
export * from "./support.vue?vue&type=script&lang=ts&"
import style0 from "./support.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports